
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { FileText } from 'lucide-react';

interface TermsSectionProps {
  terms?: string;
  requirements?: string;
  refundPolicy?: string;
}

export function TermsSection({ terms, requirements, refundPolicy }: TermsSectionProps) {
  if (!terms && !requirements && !refundPolicy) return null;
  
  return (
    <section id="terms" className="py-6 border-t">
      <h2 className="text-2xl font-bold mb-6">Terms & Policies</h2>
      
      <div className="space-y-4">
        {terms && (
          <Card>
            <CardContent className="p-6">
              <h3 className="text-lg font-semibold mb-3">Terms of Use</h3>
              <div className="prose max-w-none">
                <p className="text-muted-foreground">{terms}</p>
              </div>
            </CardContent>
          </Card>
        )}
        
        {refundPolicy && (
          <Card>
            <CardContent className="p-6">
              <h3 className="text-lg font-semibold mb-3">Refund Policy</h3>
              <div className="prose max-w-none">
                <p className="text-muted-foreground">{refundPolicy}</p>
              </div>
            </CardContent>
          </Card>
        )}
        
        {requirements && (
          <Card>
            <CardContent className="p-6">
              <h3 className="text-lg font-semibold mb-3">Technical Requirements</h3>
              <div className="prose max-w-none">
                <p className="text-muted-foreground">{requirements}</p>
              </div>
            </CardContent>
          </Card>
        )}
        
        <div className="text-center pt-4">
          <div className="flex justify-center gap-4 text-sm text-muted-foreground">
            <a href="/terms" className="hover:underline hover:text-foreground">Terms of Service</a>
            <a href="/privacy" className="hover:underline hover:text-foreground">Privacy Policy</a>
          </div>
        </div>
      </div>
    </section>
  );
}
